import React from "react";
import _ from "lodash";

import Api from "api";

export const FormErrors = ({ formErrors }) => (
  <div className="formErrors">
    {Object.keys(formErrors).map((fieldName, i) => {
      if (formErrors[fieldName].length > 0) {
        return (
          <p key={i}>
            {fieldName} {formErrors[fieldName]}
          </p>
        );
      } else {
        return "";
      }
    })}
  </div>
);

export default class Contact extends React.Component {
  state = {
    errors: [],
    message: null,
    fetching: false,
    sent: false
  };

  handleInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    let modelName = e.target.dataset.model || null;

    let model = null;
    if (modelName) {
      model = { ...this.state[modelName] };
    }
    model[name] = value;

    this.setState({ [modelName]: model });
  };

  getError(field) {
    let errors = this.state.errors || {};
    let error = errors.children ? errors.children[field] : undefined;
    if (error !== undefined && error.errors && error.errors.length > 0) {
      error = { message: _.join(error.errors, ", ") };
    }

    return _.find(errors, { property_path: field }) || error;
  }
  renderFieldError(field) {
    let error = this.getError(field);
    if (error === undefined) return null;
    return <small className="text-danger">{error.message}</small>;
  }

  renderError() {
    const { errors } = this.state;
    if (!errors || typeof errors !== "string") return null;
    const className = `alert alert-error flat text-center`;
    return <div className={className}>{errors}</div>;
  }
  contact = () => {
    const { contact } = this.state;
    this.setState({ fetching: true, errors: [] });
    let requestData = {
      ...contact,
      kiosk: process.env.REACT_APP_KIOSK_ID,
      validationGroups: ["API"]
    };
    Api.contact(requestData)
      .then(response => {
        this.setState({
          sent: true,
          fetching: false,
          message: response.data.message || "Message envoyé avec succès."
        });
      })
      .catch(error => {
        let errors = [];

        if (error.response && error.response.data) {
          const { data } = error.response;
          errors =
            data.validationErrors || data.errors || data.message || error;
        }

        this.setState({
          errors: errors,
          fetching: false
        });
      });
  };
  render() {
    const { sent, fetching, message } = this.state;

    return (
      <div className="container-fluid p-0 t">
        <div className="container">
          <div
            className="d-flex flex-column flex-wrap justify-content-center "
            style={{ height: "100vh" }}
          >
 
            <form>
              {message && (
                <div className="alert alert-success flat text-center">
                  {message}
                </div>
              )}
              {!sent && (
                <div>
                  <div>{this.renderError()}</div>

                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <div className="form-group">
                        <input
                          disabled={fetching}
                          required
                          type="text"
                          data-model="contact"
                          name="firstname"
                          onChange={this.handleInput}
                          className="form-control"
                          placeholder={"Prénom"}
                        />
                        {this.renderFieldError("firstname")}
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="form-group">
                        <input
                          disabled={fetching}
                          required
                          type="text"
                          data-model="contact"
                          name="lastname"
                          onChange={this.handleInput}
                          className="form-control"
                          placeholder={"Nom"}
                        />
                        {this.renderFieldError("lastname")}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <div className="form-group">
                        <input
                          disabled={fetching}
                          required
                          type="text"
                          data-model="contact"
                          name="email"
                          onChange={this.handleInput}
                          className="form-control"
                          placeholder={"Email"}
                        />
                        {this.renderFieldError("email")}
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="form-group">
                        <input
                          disabled={fetching}
                          type="text"
                          data-model="contact"
                          name="phone"
                          onChange={this.handleInput}
                          className="form-control"
                          placeholder={"Téléphone"}
                        />
                        {this.renderFieldError("phone")}
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <input
                      disabled={fetching}
                      required
                      type="text"
                      data-model="contact"
                      name="subject"
                      onChange={this.handleInput}
                      className="form-control"
                      placeholder={"Objet de la prise de contact"}
                    />
                    {this.renderFieldError("subject")}
                  </div>
                  <div className="form-group">
                    <textarea
                      disabled={fetching}
                      required
                      rows="5"
                      data-model="contact"
                      name="message"
                      onChange={this.handleInput}
                      className="form-control"
                      placeholder={"Message"}
                    ></textarea>
                    {this.renderFieldError("message")}
                  </div>

                  {fetching && (
                    <div className="d-flex flex-row justify-content-center ">
                      <div className="spinner-grow mr-3" role="status">
                        <span className="sr-only">Veuillez patienter...</span>
                      </div>
                    </div>
                  )}
                  {!fetching && (
                    <button
                      disabled={fetching}
                      type="button"
                      onClick={this.contact}
                      className="btn px-5 btn-primary"
                    >
                      Envoyer
                    </button>
                  )}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
